var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { ImageVariants } from "../../theme";
import { Image } from "./Image";
import { EmbeddedVideo } from "../Video";
// Provides the background image with optional gradient effect
// Please note that this component is dumb, it needs to be wrapped in an
// appropriate ratio to make sure it fits
export const ArtDirectedImage = (_a) => {
    var { imageUrl, imageNode, imageAlt, videoURL, hlsVideoURL, hasGradientOverlay, objectPositionLeft = "center", objectPositionTop = "center", noRatio = false, autoPlay = true, loop = true, muted = true } = _a, props = __rest(_a, ["imageUrl", "imageNode", "imageAlt", "videoURL", "hlsVideoURL", "hasGradientOverlay", "objectPositionLeft", "objectPositionTop", "noRatio", "autoPlay", "loop", "muted"]);
    // what to render
    let renderUI;
    if (imageUrl && imageUrl.length > 0) {
        renderUI = _jsx(Image, { src: imageUrl, alt: imageAlt });
    }
    if (imageNode) {
        renderUI = imageNode;
    }
    if (videoURL && videoURL.length > 0) {
        renderUI = (_jsx("video", { muted: muted, loop: loop, autoPlay: autoPlay, playsInline: true, children: _jsx("source", { src: videoURL, type: "video/mp4" }) }));
    }
    if (hlsVideoURL && hlsVideoURL.length > 0) {
        renderUI = (_jsx(EmbeddedVideo, { playback_url: hlsVideoURL, muted: muted, loop: loop, autoPlay: autoPlay, playsInline: true }));
    }
    return (_jsx(Box, Object.assign({ sx: {
            position: noRatio ? "relative" : "absolute",
            width: "100%",
            height: noRatio ? "auto" : "100%",
            overflow: "hidden",
            "::before": {
                content: '""',
                width: "100%",
                height: noRatio ? "auto" : "100%",
                position: noRatio ? "relative" : "absolute",
                overflow: "hidden",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: hasGradientOverlay
                    ? `linear-gradient(180deg, rgba(5, 30, 52, 0) 0%, rgba(5, 30, 52, 0.66) 140.62%)`
                    : "none",
                pointerEvents: "none"
            },
            "& div": {
                width: "100%"
            },
            img: {
                objectPosition: `${objectPositionLeft} ${objectPositionTop}`,
                variant: `images.${ImageVariants.cover}`
            },
            video: {
                objectPosition: `${objectPositionLeft} ${objectPositionTop}`,
                objectFit: "cover",
                width: "100%",
                height: "100%"
            },
            ".blur-up": {
                filter: "blur(5px)"
            },
            ".lazyload": {
                opacity: 0
            },
            ".lazyloading": {
                opacity: 1
            },
            ".lazyloaded": {
                opacity: 1
            }
        } }, props, { children: renderUI })));
};
//# sourceMappingURL=ArtDirectedImage.js.map